import { styled, Typography } from "@mui/material";
import { shouldForwardProp } from "../../../utils/styles";

export const CustomizedTypography = styled(Typography, {
  shouldForwardProp,
})(({ underline, uppercase }) => ({
  textDecoration: underline ? "underline" : "none",
  textTransform: uppercase ? "uppercase" : "none",
}));
